import { useMemo } from 'react'
import { Appointment, TaskListItem, TimeManagementListItem } from '@myapp/contract'
import { WeekAppointmentPill } from './WeekAppointmentPill'
import { WeekBreakPill } from './WeekBreakPill'
import { WeekTimeManagementPill } from './WeekTimeManagementPill'
import { WeekTaskPill } from './WeekTaskPill'
import { unifyWeekEntries, isAllDayTMEntry } from '../../../shared/lib/timeline/unifyWeekEntries'

interface Props {
  appointments: Appointment[]
  breakStartIso?: string
  timeManagementEntries?: TimeManagementListItem[]
  tasks?: TaskListItem[]
  isWorkingDay: boolean
  onClick: () => void
  onTimeManagementClick?: (id: number) => void
  onTaskClick?: (taskId: number) => void
}

export const WeekCell = ({ appointments, breakStartIso, timeManagementEntries, tasks, isWorkingDay: working, onClick, onTimeManagementClick, onTaskClick }: Props) => {
  const entries = useMemo(
    () => unifyWeekEntries({ appointments, breakStartIso, timeManagementEntries, tasks, isWorkingDay: working }),
    [appointments, breakStartIso, timeManagementEntries, tasks, working],
  )

  return (
    <div
      className={`min-h-[64px] p-1 flex flex-col gap-0.5 outline outline-1 outline-offset-[-0.5px] outline-slate-200 cursor-pointer ${
        working ? 'bg-white hover:bg-slate-50' : 'bg-gray-100'
      }`}
      onClick={onClick}
    >
      {entries.map((entry) =>
        entry.type === 'appointment' ? (
          <WeekAppointmentPill
            key={entry.appointment.id}
            appointment={entry.appointment}
            onClick={onClick}
          />
        ) : entry.type === 'break' ? (
          <WeekBreakPill key="break" startTimeIso={entry.startTimeIso} />
        ) : entry.type === 'task' ? (
          <WeekTaskPill
            key={`task-${entry.task.id}`}
            task={entry.task}
            onClick={onTaskClick ? () => onTaskClick(entry.task.id) : onClick}
          />
        ) : (
          <WeekTimeManagementPill key={`tm-${entry.entry.id}`} entry={entry.entry} isAllDay={isAllDayTMEntry(entry.entry)} onClick={onTimeManagementClick} />
        ),
      )}
    </div>
  )
}
